export const getParameterByName = (name, url) => {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const hasClass = (el, className) => {
  if (el.classList)
    return el.classList.contains(className);
  else
    return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
};

export const addClass = ( el, className ) => {
  if (el.classList)
    el.classList.add(className);
  else
    el.className += ' ' + className;
};

export const removeClass = ( el, className ) => {
  if (el.classList)
    el.classList.remove(className);
  else
    el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
};

export const forEach = (array, callback) => {
  for (var i = 0; i < array.length; i++) {
    callback( array[i], i);
    //callback.call(scope, array[i], i); // passes back stuff we need
  }
};

export const isMobile = () => {
  return window.matchMedia && !window.matchMedia("(min-width: 768px)").matches;
};

export const log = ( msg ) => {
  if( console && console.log ){
    console.log( msg );
  }
};


/** WEBPACK FOOTER **
 ** ./src/js/utilities.js
 **/